import { IconID } from '@thoughtspot/radiant-react/widgets/icon';
import { SpotlightItemType } from '../spotlight.types';
export const getDevelopNavItems = (t) => {
    const styleSubDescriptionKeys = [
        'EmbedDev.DevHub',
        'EmbedDev.Nav.StyleCustomizations',
    ];
    const securitySubDescriptionKeys = [
        'EmbedDev.DevHub',
        'EmbedDev.Nav.Settings',
    ];
    return [
        {
            id: 'develop-home',
            label: t('spotlight.nav.developerPortal'),
            labelKey: 'spotlight.nav.developerPortal',
            descriptionKeys: ['spotlight.nav.developerPortalDesc'],
            icon: IconID.CODE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop',
            keywords: ['developer', 'embed', 'api', 'customize', 'portal'],
        },
        {
            id: 'develop-playground-search',
            label: t('spotlight.nav.visualEmbedPlayground'),
            labelKey: 'spotlight.nav.visualEmbedPlayground',
            descriptionKeys: ['spotlight.nav.visualEmbedPlaygroundDesc'],
            icon: IconID.SEARCH_V2,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/playground/search',
            keywords: ['playground', 'embed', 'search', 'visual', 'sdk'],
        },
        {
            id: 'develop-playground-liveboard',
            label: t('spotlight.nav.liveboardEmbedPlayground'),
            labelKey: 'spotlight.nav.liveboardEmbedPlayground',
            descriptionKeys: ['spotlight.nav.liveboardEmbedPlaygroundDesc'],
            icon: IconID.LIVEBOARD_V2,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/playground/liveboard',
            keywords: ['playground', 'embed', 'liveboard', 'dashboard', 'sdk'],
        },
        {
            id: 'develop-rest-api-v2',
            label: t('spotlight.nav.restApiV2'),
            labelKey: 'spotlight.nav.restApiV2',
            descriptionKeys: ['spotlight.nav.restApiV2Desc'],
            icon: IconID.CODE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/api/rest/playgroundV2_0',
            keywords: ['rest', 'api', 'v2', 'playground', 'developer'],
        },
        {
            id: 'develop-rest-api-v1',
            label: t('spotlight.nav.restApiV1'),
            labelKey: 'spotlight.nav.restApiV1',
            descriptionKeys: ['spotlight.nav.restApiV1Desc'],
            icon: IconID.CODE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/api/rest/playgroundV1',
            keywords: ['rest', 'api', 'v1', 'playground', 'developer'],
        },
        {
            id: 'develop-graphql',
            label: t('spotlight.nav.graphqlPlayground'),
            labelKey: 'spotlight.nav.graphqlPlayground',
            descriptionKeys: ['spotlight.nav.graphqlPlaygroundDesc'],
            icon: IconID.CODE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/api/graphql/playground',
            keywords: ['graphql', 'api', 'playground', 'developer', 'query'],
        },
        {
            id: 'develop-theme-builder',
            label: t('EmbedDev.Nav.ThemeBuilder'),
            labelKey: 'EmbedDev.Nav.ThemeBuilder',
            descriptionKeys: ['spotlight.nav.themeBuilder.description'],
            icon: IconID.AXIS_SETTINGS,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/playground/theme-builder',
            keywords: ['theme', 'builder', 'customize', 'style', 'design'],
        },
        {
            id: 'develop-actions',
            label: t('spotlight.nav.actionsCustomization'),
            labelKey: 'spotlight.nav.actionsCustomization',
            descriptionKeys: ['spotlight.nav.actionsCustomizationDesc'],
            icon: IconID.AXIS_SETTINGS,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/actionsCustomization',
            keywords: ['actions', 'customize', 'developer', 'embed'],
        },
        {
            id: 'develop-style',
            label: t('spotlight.nav.styleCustomizations'),
            labelKey: 'spotlight.nav.styleCustomizations',
            descriptionKeys: ['spotlight.nav.styleCustomizationsDesc'],
            icon: IconID.AXIS_SETTINGS,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/styleCustomization',
            keywords: ['style', 'customize', 'theme', 'appearance', 'design'],
        },
        {
            id: 'develop-style-logo-default',
            label: t('styleCustomizer.appLogoSelector.HEADER'),
            labelKey: 'styleCustomizer.appLogoSelector.HEADER',
            descriptionKeys: styleSubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/styleCustomization',
            keywords: ['logo', 'favicon', 'branding', 'style', 'develop'],
        },
        {
            id: 'develop-style-logo-wide',
            label: t('styleCustomizer.wideAppLogoSelector.HEADER'),
            labelKey: 'styleCustomizer.wideAppLogoSelector.HEADER',
            descriptionKeys: styleSubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/styleCustomization',
            keywords: ['logo', 'wide', 'branding', 'style', 'develop'],
        },
        {
            id: 'develop-style-chart-fonts',
            label: t('styleCustomizer.chartFontSelector.HEADER'),
            labelKey: 'styleCustomizer.chartFontSelector.HEADER',
            descriptionKeys: styleSubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/styleCustomization',
            keywords: ['font', 'chart', 'visualization', 'typography', 'develop'],
        },
        {
            id: 'develop-style-table-fonts',
            label: t('styleCustomizer.tableFontSelector.HEADER'),
            labelKey: 'styleCustomizer.tableFontSelector.HEADER',
            descriptionKeys: styleSubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/styleCustomization',
            keywords: ['font', 'table', 'visualization', 'typography', 'develop'],
        },
        {
            id: 'develop-style-nav-color',
            label: t('styleCustomizer.appPanelColorSelector.HEADER'),
            labelKey: 'styleCustomizer.appPanelColorSelector.HEADER',
            descriptionKeys: styleSubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/styleCustomization',
            keywords: ['navigation', 'panel', 'color', 'style', 'develop'],
        },
        {
            id: 'develop-style-chart-colors',
            label: t('styleCustomizer.chartColorPaletteEditor.HEADER'),
            labelKey: 'styleCustomizer.chartColorPaletteEditor.HEADER',
            descriptionKeys: styleSubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/styleCustomization',
            keywords: ['chart', 'color', 'palette', 'style', 'develop'],
        },
        {
            id: 'develop-style-footer-text',
            label: t('styleCustomizer.footerText.HEADER'),
            labelKey: 'styleCustomizer.footerText.HEADER',
            descriptionKeys: styleSubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/styleCustomization',
            keywords: ['footer', 'text', 'embed', 'embedded', 'develop'],
        },
        {
            id: 'develop-links',
            label: t('spotlight.nav.customLinks'),
            labelKey: 'spotlight.nav.customLinks',
            descriptionKeys: ['spotlight.nav.customLinksDesc'],
            icon: IconID.AXIS_SETTINGS,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/links',
            keywords: ['links', 'custom', 'navigation'],
        },
        {
            id: 'develop-security',
            label: t('spotlight.nav.securitySettings'),
            labelKey: 'spotlight.nav.securitySettings',
            descriptionKeys: ['spotlight.nav.securitySettingsDesc'],
            icon: IconID.AXIS_SETTINGS,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/securitySettings',
            keywords: ['security', 'settings', 'cors', 'csp', 'developer'],
        },
        {
            id: 'develop-security-mandatory',
            label: t('EmbedDev.Settings.mandatorySecuritySettingsHeader'),
            labelKey: 'EmbedDev.Settings.mandatorySecuritySettingsHeader',
            descriptionKeys: securitySubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/securitySettings',
            keywords: ['cors', 'frame', 'ancestors', 'csp', 'security', 'mandatory'],
        },
        {
            id: 'develop-security-auth-access',
            label: t('EmbedDev.Settings.authenticationAndAccessHeader'),
            labelKey: 'EmbedDev.Settings.authenticationAndAccessHeader',
            descriptionKeys: securitySubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/securitySettings',
            keywords: ['authentication', 'access', 'saml', 'token', 'security'],
        },
        {
            id: 'develop-security-styling',
            label: t('EmbedDev.Settings.stylingResourcesHeader'),
            labelKey: 'EmbedDev.Settings.stylingResourcesHeader',
            descriptionKeys: securitySubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/securitySettings',
            keywords: ['styling', 'css', 'font', 'image', 'csp', 'security'],
        },
        {
            id: 'develop-security-custom-actions',
            label: t('EmbedDev.Settings.customActionsAndWebHooksResourcesHeader'),
            labelKey: 'EmbedDev.Settings.customActionsAndWebHooksResourcesHeader',
            descriptionKeys: securitySubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/securitySettings',
            keywords: ['custom', 'actions', 'webhooks', 'csp', 'connect', 'security'],
        },
        {
            id: 'develop-security-custom-charting',
            label: t('EmbedDev.Settings.customChartingResourcesHeader'),
            labelKey: 'EmbedDev.Settings.customChartingResourcesHeader',
            descriptionKeys: securitySubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/securitySettings',
            keywords: ['custom', 'charting', 'csp', 'frame', 'security'],
        },
        {
            id: 'develop-security-scripts',
            label: t('EmbedDev.Settings.scriptResourcesHeader'),
            labelKey: 'EmbedDev.Settings.scriptResourcesHeader',
            descriptionKeys: securitySubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/securitySettings',
            keywords: ['script', 'csp', 'resources', 'security'],
        },
        {
            id: 'develop-security-cookies',
            label: t('EmbedDev.Settings.browserCookieSettingsHeader'),
            labelKey: 'EmbedDev.Settings.browserCookieSettingsHeader',
            descriptionKeys: securitySubDescriptionKeys,
            icon: IconID.PAPER_PLANE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/securitySettings',
            keywords: ['browser', 'cookie', 'partitioned', 'security'],
        },
        {
            id: 'develop-webhooks',
            label: t('EmbedDev.WebhooksV2.Headers.Landing.Title'),
            labelKey: 'EmbedDev.WebhooksV2.Headers.Landing.Title',
            descriptionKeys: ['spotlight.nav.webhooks.description'],
            icon: IconID.CODE,
            type: SpotlightItemType.NAVIGATION,
            path: '/develop/webhooks',
            keywords: ['webhooks', 'events', 'notifications', 'developer'],
        },
    ];
};
export const DEVELOP_NAV_ITEMS = getDevelopNavItems((key) => key);
//# sourceMappingURL=develop.js.map